export default "__VITE_ASSET__BI2Jkq56__"